import { render } from "./Persona.vue?vue&type=template&id=f03cafd2&scoped=true"
import script from "./Persona.vue?vue&type=script&lang=js"
export * from "./Persona.vue?vue&type=script&lang=js"

import "@/assets/css/tablaHover.css?vue&type=style&index=0&id=f03cafd2&scoped=true&lang=css"
import "@/assets/css/listaRegistros.css?vue&type=style&index=1&id=f03cafd2&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f03cafd2"]])

export default __exports__